import React from 'react';
import { useI18n } from '@oneaudi/i18n-context';
import { TextButton } from '@oneaudi/unified-web-components';
import styled from 'styled-components';
import { messages } from '../../../i18n/messages';
import mapContext from '../../../contexts/map-context';
import { ActionTypes } from '../../../contexts/reducers/map-reducer';

const getNumberOfActiveFilters = (
  authorDefinedFilters: string[],
  preselectedFilters: string[] = [],
  userSelectedFilters: string[] = [],
): number => {
  const preselectedAuthorDefinedFilters = authorDefinedFilters.filter((value) =>
    preselectedFilters.includes(value),
  );
  return preselectedAuthorDefinedFilters.length + userSelectedFilters.length;
};

export default function FiltersButton() {
  const { authorDefinedFilters, preselectedFilters, userSelectedFilters } =
    mapContext.useMapState();
  const dispatch = mapContext.useMapDispatch();

  const numberOfActiveFilters = getNumberOfActiveFilters(
    authorDefinedFilters,
    preselectedFilters,
    userSelectedFilters,
  );

  return (
    <CustomCta
      data-test-id="filters-button-component"
      onClick={() => {
        dispatch({ type: ActionTypes.setIsFiltersOverlayOpen, payload: true });
      }}
      variant="primary"
      size="sm"
      iconPosition="leading"
      icon="options"
      aria-label={useI18n(messages.filter)}
      hasFilter={numberOfActiveFilters !== 0}
    >
      {numberOfActiveFilters !== 0 && `(${numberOfActiveFilters})`}
    </CustomCta>
  );
}

const CustomCta = styled(TextButton)<{ hasFilter: boolean }>`
  padding: ${(props) => (props.hasFilter ? '' : '12px')};
  height: fit-content;
`;
